import { MonacoLanguageDefinition } from '@theia-lved-core/types/monaco-language';
import * as monaco from '@theia/monaco-editor-core';

export const CMAKE_LANGUAGE_ID: string = 'cmake';

const configuration: monaco.languages.LanguageConfiguration = {
    comments: {
        lineComment: '#'
    },
    brackets: [
        ['(', ')'],
        ['[', ']'],
        ['{', '}']
    ],
    autoClosingPairs: [
        { open: '(', close: ')' },
        { open: '[', close: ']' },
        { open: '{', close: '}' },
        { open: '"', close: '"' }
    ],
    surroundingPairs: [
        { open: '(', close: ')' },
        { open: '[', close: ']' },
        { open: '{', close: '}' },
        { open: '"', close: '"' }
    ]
};

const language: monaco.languages.IMonarchLanguage = {
    defaultToken: '',
    tokenPostfix: '.cmake',
    ignoreCase: true,
    commands: [
        'add_compile_definitions',
        'add_compile_options',
        'add_custom_command',
        'add_custom_target',
        'add_definitions',
        'add_dependencies',
        'add_executable',
        'add_library',
        'add_subdirectory',
        'aux_source_directory',
        'block',
        'break',
        'cmake_language',
        'cmake_minimum_required',
        'cmake_parse_arguments',
        'cmake_path',
        'cmake_policy',
        'configure_file',
        'continue',
        'else',
        'elseif',
        'endforeach',
        'endfunction',
        'endif',
        'endmacro',
        'endwhile',
        'execute_process',
        'file',
        'find_file',
        'find_library',
        'find_package',
        'find_path',
        'find_program',
        'foreach',
        'function',
        'get_cmake_property',
        'get_directory_property',
        'get_filename_component',
        'get_property',
        'if',
        'include',
        'include_directories',
        'include_guard',
        'install',
        'link_directories',
        'list',
        'macro',
        'mark_as_advanced',
        'math',
        'message',
        'option',
        'project',
        'return',
        'separate_arguments',
        'set',
        'set_property',
        'set_target_properties',
        'string',
        'target_compile_definitions',
        'target_compile_features',
        'target_compile_options',
        'target_include_directories',
        'target_link_directories',
        'target_link_libraries',
        'target_link_options',
        'target_sources',
        'unset',
        'while'
    ],
    flowControl: [
        'if',
        'elseif',
        'else',
        'endif',
        'foreach',
        'endforeach',
        'while',
        'endwhile',
        'function',
        'endfunction',
        'macro',
        'endmacro',
        'block',
        'return',
        'break',
        'continue'
    ],
    variables: [
        'and',
        'cache',
        'command',
        'defined',
        'equal',
        'exists',
        'false',
        'greater',
        'in_list',
        'is_absolute',
        'less',
        'matches',
        'not',
        'off',
        'on',
        'or',
        'parent_scope',
        'path_equal',
        'policy',
        'target',
        'test',
        'true'
    ],
    operators: [
        'and',
        'or',
        'not',
        'equal',
        'less',
        'greater',
        'matches',
        'in_list',
        'path_equal',
        'version_equal',
        'version_less',
        'version_greater'
    ],
    tokenizer: {
        root: [
            { include: '@whitespace' },
            [/\$<[^>]+>/, 'type'],
            [/\$ENV\{[^}]+\}/, 'variable.predefined'],
            [/\$CACHE\{[^}]+\}/, 'variable.predefined'],
            [/\$\{[^}]+\}/, 'variable'],
            [
                /[A-Za-z_][A-Za-z0-9_]*/,
                {
                    cases: {
                        '@flowControl': 'keyword.control',
                        '@commands': 'keyword',
                        '@operators': 'operator',
                        '@variables': 'variable.predefined',
                        '@default': 'identifier'
                    }
                }
            ],
            [/[()\[\]{}]/, '@brackets'],
            [/[+-]?\d+/, 'number'],
            [/[;,]/, 'delimiter'],
            [/"/, 'string', '@string'],
            [/[^#\s()\[\]{}";$,]+/, 'string']
        ],
        whitespace: [
            [/[ \t\r\n]+/, ''],
            [/#.*$/, 'comment']
        ],
        string: [
            [/[^\\"$]+/, 'string'],
            [/\$<[^>]+>/, 'type'],
            [/\$ENV\{[^}]+\}/, 'variable.predefined'],
            [/\$CACHE\{[^}]+\}/, 'variable.predefined'],
            [/\$\{[^}]+\}/, 'variable'],
            [/\\./, 'string.escape'],
            [/"/, 'string', '@pop']
        ]
    }
};

export const cmakeLanguageDefinition: MonacoLanguageDefinition = {
    id: CMAKE_LANGUAGE_ID,
    aliases: ['CMake', 'cmake'],
    extensions: ['.cmake'],
    filenames: ['CMakeLists.txt'],
    configuration,
    language
};
